var React = require('react');

function Camera (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.75.5L4.378 2H2C1.175 2 .5 2.675.5 3.5v9c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5h-2.377L10.25.5h-4.5zM8 11.75c-2.07 0-3.75-1.68-3.75-3.75 0-2.07 1.68-3.75 3.75-3.75 2.07 0 3.75 1.68 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75zm0-1.35a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8z","fill":"currentColor","fillRule":"evenodd"}));
}

Camera.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14"};

module.exports = Camera;

Camera.default = Camera;
